
export const Termsandconditions = () => {
  return (
    <>
       <p style={{ fontWeight: 500, marginTop: "10px" ,  fontFamily: "Rubik-Regular"}}>
          The ARN holder has disclosed to me/us all the commissions in the form
          of trail commission or any other mode, payable to him for the
          different competing Schemes of various Mutual Funds from amongst which
          the Scheme is being recommended to me/us.
        </p>
        <p style={{ fontWeight: 500, marginTop: "10px" , fontFamily: "Rubik-Regular"}}>
          Disclaimer: The Registrar of the AMC will allot the number of units
          for the total investment amount. The number of Units allotted by the
          Registrar will reflect in your online account statement within 2
          working days.
        </p>
    </>
  );
};
